export default "__VITE_ASSET__6IPebNbb__"